<template>
  <div>
    <p class="title-page">Limpar Descontos</p>
    <TableClean />
  </div>
</template>

<script>
import TableClean from "../components/TableClean.vue";

export default {
  name: "TableCleanPromotion",

  components: {
    TableClean,
  },
};
</script>
